/* eslint-disable no-lone-blocks */
import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import { Link, useNavigate, useLocation } from "react-router-dom";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import PubSub from "pubsub-js";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { handleUppercaseChange } from "../common/UpperCaseMethod";

const ProductEdit = (props) => {
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location.state ? location.state : {});
  const [rateLineItems, setRateLineItems] = useState([]);
  const [newRow, setNewRow] = useState({
    drive_type: "",
    motor_type: "",
    metal_type: "",
    door_type: "",
    min_height: "",
    max_height: "",
    rate: "",
  });
  const [refreshRateItems, setRefreshRateItems] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editRow, setEditRow] = useState(null);

  useEffect(() => {
    if (product.id) {
      fetchRateLineItems();
    }
  }, [product.id, refreshRateItems]);

  const fetchRateLineItems = async () => {
    if (!product.id) return;
    const items = await fuziElevatorsApi.fetchProductRateLineItemsByProductId(product.id);
    setRateLineItems(items || []);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
  };

  const handleNewRowChange = (e) => {
    const { name, value } = e.target;
    setNewRow({ ...newRow, [name]: value });
  };

  const handleEditRowChange = (e) => {
    const { name, value } = e.target;
    setEditRow({ ...editRow, [name]: value });
  };

  // const checkRequiredFields = () => {
  //   if (
  //     product.product_name &&
  //     product.product_name.trim() !== "" &&
  //     product.product_category &&
  //     product.product_category.trim() !== "" &&
  //     product.calculation_type &&
  //     product.calculation_type.trim() !== ""
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };


  //Imran Khan Added condition for Product Name
  const checkRequiredFields = () => {
    if (product.product_name && product.product_name.trim() !== "") {
      return false;
    }
    return true;
  };
  //End Here

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result = {};
    if (product.id) {
      result = await fuziElevatorsApi.saveProduct(product);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/products/${product.id}`, { state: { ...product, ...result?.data } });
      }
    } else {
      const createResult = await fuziElevatorsApi.createProduct(product);
      if (createResult?.data) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/products/${createResult.id || createResult.data?.id}`, {
          state: createResult.data || createResult,
        });
      }
    }
  };

  const handleCancel = () => {
    if (product.id) {
      navigate("/products/" + product.id, { state: product });
    } else {
      navigate(`/products`);
    }
  };

  const handleAddRow = async () => {
    if (!product.id) return;
    const minH = newRow.min_height ? parseFloat(newRow.min_height) : null;
    const maxH = newRow.max_height ? parseFloat(newRow.max_height) : null;
    if (minH != null && maxH != null && minH > maxH) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Validation Error",
        message: "Min height must be less than or equal to max height",
      });
      return;
    }
    const res = await fuziElevatorsApi.createProductRateLineItem({
      product_id: product.id,
      drive_type: newRow.drive_type || null,
      motor_type: newRow.motor_type || null,
      metal_type: newRow.metal_type || null,
      door_type: newRow.door_type || null,
      min_height: minH,
      max_height: maxH,
      rate: newRow.rate ? parseFloat(newRow.rate) : null,
    });
    if (res?.data) {
      setNewRow({
        drive_type: "",
        motor_type: "",
        metal_type: "",
        door_type: "",
        min_height: "",
        max_height: "",
        rate: "",
      });
      setRefreshRateItems((p) => !p);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Row Added",
        message: "Pricing row added successfully",
      });
    } else if (res?.errors) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Error",
        message: res.errors,
      });
    }
  };

  const handleEditRow = (row) => {
    setEditRow({ ...row });
    setShowEditModal(true);
  };

  const handleSaveEditRow = async () => {
    if (!editRow?.id) return;
    const minH = editRow.min_height != null && editRow.min_height !== "" ? parseFloat(editRow.min_height) : null;
    const maxH = editRow.max_height != null && editRow.max_height !== "" ? parseFloat(editRow.max_height) : null;
    if (minH != null && maxH != null && minH > maxH) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Validation Error",
        message: "Min height must be less than or equal to max height",
      });
      return;
    }
    const res = await fuziElevatorsApi.updateProductRateLineItem(editRow.id, {
      drive_type: editRow.drive_type || null,
      motor_type: editRow.motor_type || null,
      metal_type: editRow.metal_type || null,
      door_type: editRow.door_type || null,
      min_height: minH,
      max_height: maxH,
      rate: editRow.rate != null && editRow.rate !== "" ? parseFloat(editRow.rate) : null,
    });
    if (res?.success) {
      setShowEditModal(false);
      setEditRow(null);
      setRefreshRateItems((p) => !p);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Row Updated",
        message: "Pricing row updated successfully",
      });
    } else if (res?.errors) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Error",
        message: res.errors,
      });
    }
  };

  const handleDeleteRow = async (id) => {
    const res = await fuziElevatorsApi.deleteProductRateLineItem(id);
    if (res?.success) {
      setRefreshRateItems((p) => !p);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Row Deleted",
        message: "Pricing row deleted successfully",
      });
    }
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ProductEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8} className="pb-1 pt-2">
            <Link className="nav-link" to="/products">
              Home <i className="fa-solid fa-chevron-right"></i>{" "}
              <div style={{ color: "#23468c", display: "inline" }}>
                Products
              </div>
            </Link>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col></Col>
          <Col lg={10}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header ">
                <Col lg={8}>
                  {product.id ? <h5>Edit Product</h5> : <h5>Create Product</h5>}
                </Col>
                <Col lg={4} className="d-flex gap-3 justify-content-end">
                  <Button size="sm" className="btn-save" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button size="sm" className="btn-cancel" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Card className="mb-3">
                <Card.Header>Section 1: Product Details</Card.Header>
                <Card.Body>
                  <Row className="ibs-edit-form pb-3">
                    {product.id && (
                      <Col lg={6}>
                        <Form.Group className="mx-3" controlId="formProductCode">
                          <Form.Label className="form-view-label" htmlFor="formProductCode">
                            Product Code
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="product_code"
                            placeholder="Enter Product Code"
                            value={product.product_code || ""}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    )}
                    <Col lg={6}>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label" htmlFor="formProductName">
                          Product Name
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="product_name"
                          placeholder="Enter Product Name"
                          value={product.product_name || ""}
                          onChange={(e) => handleUppercaseChange(e, handleChange)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide Product Name.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label" htmlFor="formUnit">
                          Unit
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="unit"
                          placeholder="Enter Unit"
                          value={product.unit || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label" htmlFor="formBaseQuantity">
                          Base Quantity
                        </Form.Label>
                        <Form.Control
                          type="number"
                          step="0.0001"
                          name="base_quantity"
                          placeholder="Enter Base Quantity"
                          value={product.base_quantity ?? ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12}>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label" htmlFor="formFormulaText">
                          Formula Text
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          name="formula_text"
                          placeholder="Enter Formula Text"
                          value={product.formula_text || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    {product.id && (
                      <Col lg={6}>
                        <Form.Group className="mx-3">
                          <Form.Label className="form-view-label" htmlFor="formIsActive">
                            Is Active
                          </Form.Label>
                          <Form.Select
                            name="is_active"
                            value={product.is_active === false ? "false" : "true"}
                            onChange={(e) =>
                              setProduct({
                                ...product,
                                is_active: e.target.value === "true",
                              })
                            }
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                </Card.Body>
              </Card>

              {product.id && (
                <Card className="mb-3">
                  <Card.Header>Section 2: Pricing Matrix (Child Grid)</Card.Header>
                  <Card.Body>
                    <Row className="ibs-edit-form pb-3">
                      <Col lg={12}>
                        <Table striped bordered hover size="sm" className="mx-0">
                          <thead>
                            <tr>
                              <th>Drive Type</th>
                              <th>Motor Type</th>
                              <th>Metal Type</th>
                              <th>Door Type</th>
                              <th>Min Height</th>
                              <th>Max Height</th>
                              <th>Rate</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rateLineItems.map((row) => (
                              <tr key={row.id}>
                                <td>{row.drive_type ?? "-"}</td>
                                <td>{row.motor_type ?? "-"}</td>
                                <td>{row.metal_type ?? "-"}</td>
                                <td>{row.door_type ?? "-"}</td>
                                <td>{row.min_height ?? "-"}</td>
                                <td>{row.max_height ?? "-"}</td>
                                <td>{row.rate ?? "-"}</td>
                                <td>
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    className="me-1"
                                    onClick={() => handleEditRow(row)}
                                  >
                                    <i className="fa-solid fa-pen"></i>
                                  </Button>
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => handleDeleteRow(row.id)}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td>
                                <Form.Control
                                  type="text"
                                  placeholder="Drive Type"
                                  name="drive_type"
                                  value={newRow.drive_type}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  placeholder="Motor Type"
                                  name="motor_type"
                                  value={newRow.motor_type}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  placeholder="Metal Type"
                                  name="metal_type"
                                  value={newRow.metal_type}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  placeholder="Door Type"
                                  name="door_type"
                                  value={newRow.door_type}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  step="0.01"
                                  placeholder="Min"
                                  name="min_height"
                                  value={newRow.min_height}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  step="0.01"
                                  placeholder="Max"
                                  name="max_height"
                                  value={newRow.max_height}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  step="0.01"
                                  placeholder="Rate"
                                  name="rate"
                                  value={newRow.rate}
                                  onChange={handleNewRowChange}
                                />
                              </td>
                              <td>
                                <Button size="sm" className="btn-save" onClick={handleAddRow}>
                                  <i className="fa-solid fa-plus"></i> Add Row
                                </Button>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Pricing Row</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editRow && (
            <Row>
              <Col lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label>Drive Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="drive_type"
                    value={editRow.drive_type || ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label>Motor Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="motor_type"
                    value={editRow.motor_type || ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label>Metal Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="metal_type"
                    value={editRow.metal_type || ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label>Door Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="door_type"
                    value={editRow.door_type || ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="mb-2">
                  <Form.Label>Min Height</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="min_height"
                    value={editRow.min_height ?? ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="mb-2">
                  <Form.Label>Max Height</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="max_height"
                    value={editRow.max_height ?? ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group className="mb-2">
                  <Form.Label>Rate</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="rate"
                    value={editRow.rate ?? ""}
                    onChange={handleEditRowChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveEditRow}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  );
};

export default ProductEdit;
